export default __webpack_public_path__ + "static/media/QR-VR.c293c566.png";